import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NotificationListModule } from '@portal-core/notifications/components/notification-list/notification-list.module';
import { ReviewFileNotificationListComponent } from './review-file-notification-list.component';

@NgModule({
  declarations: [
    ReviewFileNotificationListComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressBarModule,
    NotificationListModule
  ],
  exports: [
    ReviewFileNotificationListComponent
  ]
})
export class ReviewFileNotificationListModule { }
